export const BANNERADDITIONALINFO='BannerAdditionalInfo';
export const PLANSTATUSWITHCARDS='PlanStatusWithCards';
export const FINDCARE='FindCare';